import { render } from "./ProductEditCustomer.vue?vue&type=template&id=4d56fd85"
import script from "./ProductEditCustomer.vue?vue&type=script&lang=js"
export * from "./ProductEditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__